import { Stack } from "@/Components/v2/atoms/Stack";
import { Box } from "@/Components/v2/atoms/Box";
import { Typography } from "@mui/material";

type MetaFieldProps = {
  value: string;
  title?: string;
};

const MetaField = ({ title, value }: MetaFieldProps) => {
  return (
    <Box
      sx={{
        backgroundColor: (theme) => theme.palette.pill.background,
        color: (theme) => theme.palette.brandedTypography.textColor,
        padding: "0.7rem",
        paddingRight: "1.5rem",
        margin: "0.5rem",
        height: "1.3rem",
        borderRadius: "0.5rem",
        width: "fit-content",
        minWidth: "10rem",
      }}
    >
      <Stack direction="row" spacing={1}>
        {title && (
          <Typography
            component="span"
            variant="body2"
            sx={{
              fontWeight: "600",
              pr: 0.2,
            }}
          >
            {title}
          </Typography>
        )}
        <Typography variant="body2" fontWeight={400}>
          {value}
        </Typography>
      </Stack>
    </Box>
  );
};

export default MetaField;
